<div class="sidebar" data-color="white" data-active-color="danger">
  <div class="logo">
    <a [routerLink]="['/home']" class="simple-text logo-mini">
      <div class="logo-image-small">
        <img src="./assets/images/logo-small.png">
      </div>
      <!-- <p>CT</p> -->
    </a>
    <a [routerLink]="['/home']" class="simple-text logo-normal">
      Prometheus
      <!-- <div class="logo-image-big">
        <img src="../assets/img/logo-big.png">
      </div> -->
    </a>
  </div>
  <div *ngIf="loggedIn" class="sidebar-wrapper">
    <ul class="nav">
      <li *ngFor="let api of apis" routerLinkActive="active">
        <a [routerLink]="api.apiUrl" [queryParams]="{id:api.id}">
          <i  [ngClass]="api.displayIcon"></i>
          <p>{{api.displayName}}</p>
        </a>
      </li>
    </ul>
  </div>
</div>
